import React from 'react';
import { DashboardStatusTag } from '../components/dashboard';

const maintText = {
  OVERDUE: 'Overdue',
  DUE_SOON: 'Due soon',
  UPCOMING: 'Upcoming',
  ON_TRACK: 'On track',
};

const maintColor = {
  OVERDUE: 'red',
  DUE_SOON: 'orange',
  UPCOMING: 'blue',
  ON_TRACK: 'green',
};

const serviceText = {
  IN_SERVICE: 'In service',
  DOWN: 'Down',
  WAITING_ON_PARTS: 'Waiting on parts',
};

const serviceColor = {
  IN_SERVICE: 'blue',
  DOWN: 'red',
  WAITING_ON_PARTS: 'gold',
};

export function normalizeMaintStatus(status) {
  const key = String(status || '').trim().toUpperCase();
  return key === 'NEEDS_SETUP' ? 'ON_TRACK' : key;
}

export function renderMaintTag(status) {
  const key = normalizeMaintStatus(status);
  const label = maintText[key];
  return label ? (
    <DashboardStatusTag color={maintColor[key] || 'default'}>{label}</DashboardStatusTag>
  ) : (
    '—'
  );
}

export function renderServiceTag(status) {
  const key = String(status || '').trim().toUpperCase();
  const label = serviceText[key];
  return label ? (
    <DashboardStatusTag color={serviceColor[key] || 'default'}>{label}</DashboardStatusTag>
  ) : (
    '—'
  );
}
